module.exports = __webpack_public_path__ + "img/stock2.8ea8ccab.png";